<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet">
        <defs>
            <clipPath :id="`clip-path-${uniqueId}`">
                <rect id="Rectangle_230" data-name="Rectangle 230" width="48" height="48" rx="6" fill="#fff" />
            </clipPath>
        </defs>
        <g
            id="Icons_I_payment_transparent_apple_pay"
            data-name="Icons / I_payment_transparent_apple_pay"
            :clip-path="`url(#clip-path-${uniqueId})`">
            <rect
                id="Rectangle_229"
                data-name="Rectangle 229"
                width="46"
                height="46"
                rx="5.5"
                transform="translate(1 1)"
                fill="rgba(255,255,255,0)"
                stroke="rgba(238,238,238,0)"
                stroke-width="1" />
            <path
                id="Path_277"
                data-name="Path 277"
                d="M9.855,10.017a2.465,2.465,0,0,0,.572-1.767A2.456,2.456,0,0,0,8.8,9.093a2.323,2.323,0,0,0-.585,1.7,2.054,2.054,0,0,0,1.644-.775Zm.564.9c-.908-.055-1.68.515-2.113.515s-1.1-.488-1.815-.474a2.672,2.672,0,0,0-2.275,1.381c-.975,1.68-.258,4.175.69,5.544.462.678,1.017,1.423,1.748,1.4.69-.027.963-.447,1.8-.447s1.083.447,1.815.435c.758-.015,1.233-.679,1.694-1.357a6.023,6.023,0,0,0,.758-1.559,2.465,2.465,0,0,1-1.476-2.237,2.5,2.5,0,0,1,1.193-2.1A2.593,2.593,0,0,0,10.419,10.916Zm6.816,3.48h1.81A1.9,1.9,0,0,0,21.2,12.373a1.9,1.9,0,0,0-2.15-2.016H17.235Zm2.232-5.37a3.191,3.191,0,0,1,3.348,3.34,3.226,3.226,0,0,1-3.4,3.354H17.234v3.474H15.656V9.026ZM28,16.431v-.57l-1.755.113c-.987.063-1.5.429-1.5,1.071,0,.619.534,1.021,1.373,1.021A1.722,1.722,0,0,0,28,16.431Zm-4.792.656c0-1.3.994-2.051,2.826-2.163L28,14.8V14.24c0-.825-.542-1.275-1.508-1.275A1.386,1.386,0,0,0,24.995,14H23.571c.043-1.317,1.282-2.276,2.961-2.276,1.8,0,2.98.945,2.98,2.41v5.06H28.053V17.975h-.035a2.6,2.6,0,0,1-2.325,1.3A2.234,2.234,0,0,1,23.205,17.087Zm7.65,4.828V20.7c.1.014.339.027.465.027a1.257,1.257,0,0,0,1.332-1.056l.141-.45-2.67-7.4h1.648l1.86,6h.036l1.86-6h1.6l-2.767,7.771c-.635,1.784-1.361,2.369-2.9,2.369a4.279,4.279,0,0,1-.613-.044Z"
                transform="translate(3.75 8.25)"
                fill="#111"
                fill-rule="evenodd" />
        </g>
    </svg>
</template>

<script lang="ts" setup>
    const uniqueId = useId();
</script>
